<template>
  <Modal v-model="model" sticky reset-drag-position title="音频播放" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="record_file_pop" width="500">
    <div class="record_file">
      <audio controls="controls" ref="audio" id="autoPlayEqu0" controlsList="nodownload"></audio>
    </div>
  </Modal>
</template>

<script>
    export default {
        name: "PlayMusicPop",
        props: {
          showRecordFile:Boolean,
          recordFile:String
        },
        data(){
          return {
            model:false,
            url:''
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeRecordfile",false);
          }
        },
        watch:{
          showRecordFile:function () {
            this.model=this.showRecordFile;
            this.$refs.audio.src=this.recordFile;
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue